/*********************************************************
 * Third Components
*********************************************************/
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

/*********************************************************
 * Components
*********************************************************/
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Select, Button } from 'Components';

/*********************************************************
 * Redux
*********************************************************/
import {
  showModalBulkEditLandmark,
  editLandmarkBulk
} from 'Redux/actions';

/*********************************************************
 * Modal to delete landmarks elements
*********************************************************/
const ModalBulkEditLandmarks = (props) => {

  const { messages } = props

  const dispatch = useDispatch()
  const [groupSelect, setGroupSelect] = useState();

  const {
    landmarkGroups,
    smodalLandmarkBulkEdit,
    landmarkItemsSelected
  } = useSelector((state) => state.realtimeMapLandmarkModuleRedux);


  /*********************************************************
   * Load the landmark groups exclude param group
  *********************************************************/
  const loadLandmarkGroupsExclude = () => {
    if (landmarkItemsSelected) {
      return landmarkGroups.filter((item) => item.id != landmarkItemsSelected[0]?.groupId)
    }

    return landmarkGroups;
  }


  /*********************************************************
   * Close modal
  *********************************************************/
  const onHandleClose = (value) => dispatch(showModalBulkEditLandmark(value))


  /*********************************************************
   * Event when the user select another landmark group
  *********************************************************/
  const onChangeLandmarkGroup = (event) => {
    setGroupSelect(event)
  }

  /*********************************************************
   * Update landmark Groups
  *********************************************************/
  const onUpdateLandmarks = () => {
    const landmarksToUpdate = landmarkItemsSelected.map(item => {
      return { id: item.id, groupId: groupSelect.id }
    })
    dispatch(editLandmarkBulk({ landmarksToUpdate }))
    onHandleClose(false)
  }

  return (
    <Modal
      title={messages["realtimemaps_landmarks_groups_edit_modal"]}
      open={smodalLandmarkBulkEdit || false}
      handleClose={() => {
        onHandleClose(false)
      }}
      position="right"
      size="small"
    >
      <ModalBody>
        <div className='modalMLandmark'>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Select
                id="landmarkGroup"
                value={groupSelect}
                onChange={(event) => onChangeLandmarkGroup(event)}
                options={loadLandmarkGroupsExclude()}
                textField="name"
                valueField="id"
                placeholder={messages['realtimemaps_landmarks_groups_update_placeholder']}
              />
            </Grid>
          </Grid>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          id={'btn-cancel-bulk-edit'}
          type="button"
          onClick={(event) => {
            event.preventDefault();
            onHandleClose(false)

          }}
          className="btn-gray"
        >
          {messages['realtimemaps_landmarks_groups_delete_cancel']}
        </Button>
        <Button
          id={'btn-save-bulk-edit'}
          type="button"
          onClick={(event) => {
            event.preventDefault();
            onUpdateLandmarks();
          }}
          className="btn-blue"
        >
          {messages['save']}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalBulkEditLandmarks